import { Link } from "react-router-dom"
import { ROOT } from "../../routes/routes_name"
import useAnnouncementDetail from "./useAnnouncementDetail"
import DOMPurify from "dompurify";

const AnnouncementDetailPage = () => {
    const {
        data,
        isLoading,
        dataOthers,
        handleClickOther,
        getTimestampToDateTime,
    } = useAnnouncementDetail()
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="../assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>Detail Pengumuman</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">Detail Pengumuman</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section id="service-details" className="service-details section">
                    <div className="container">
                        <div className="row gy-5">
                            <div className="col-lg-8 ps-lg-5" data-aos="fade-up" data-aos-delay="100">
                                <img src={data.thumbnail} alt="" className="img-fluid services-img w-100" style={{
                                    height: "350px",
                                    objectFit: "cover"
                                }} />
                                <h3>{data.judul}</h3>
                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.konten) }} />
                                <div className="d-flex justify-content-center">
                                    <button type="button" class="btn btn-primary" style={{backgroundColor:'#047b91'}}>
                                        <Link to={data.file} className="btn-getstarted ">
                                            <h5 className="text-light m-0"><i className="bi bi-download"></i> Download</h5></Link>
                                    </button></div>
                            </div>
                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="service-box">
                                    <h4>Pengumuman Terkini</h4>
                                    <div className="services-list">
                                        {
                                            isLoading ? <p>Loading...</p> :

                                                dataOthers && dataOthers.map((d, i) => {
                                                    return (
                                                        <div key={i} className="row row-cols-2 mb-3" style={{ cursor: "pointer" }} onClick={() => handleClickOther(d)}>
                                                            <div className="col-3">
                                                                <img src={d.thumbnail} className="card-img-top rounded-2" alt="..." />
                                                            </div>
                                                            <div className="col-9">
                                                                <span>{d.judul}</span><br />
                                                                <span style={{ color: "grey", fontStyle: "italic" }}>{getTimestampToDateTime(d.created_at)}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div >
    )
}
export default AnnouncementDetailPage